/* istanbul ignore file */

import { isTransparent } from '@erase2d/fabric';

isTransparent.installWorker();
